import { GALLERY, MOMENTS } from '@/mocks/entertainment';

export default function Highlight() {
  return (
    <section id="gallery" className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* gallery */}
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="font-label text-sm tracking-[0.3em] text-primary-600">RAW &amp; REAL</p>
            <h3 className="mt-2 font-heading text-3xl font-black text-foreground-950">红毯生图特辑</h3>
            <p className="mt-1.5 text-sm text-foreground-600">原片直出，看现场最真实的状态与高光瞬间</p>
          </div>
          <a href="#live" className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-600">
            全部生图 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-5">
          {GALLERY.map((g, i) => (
            <figure key={g.title} className={`group overflow-hidden rounded-3xl border border-background-200 bg-background-50 ${i % 2 ? 'lg:mt-8' : ''}`}>
              <a href="#gallery" className="relative block aspect-[3/4] w-full overflow-hidden">
                <img
                  src={g.image}
                  alt={`红毯生图精选：${g.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/50 px-2.5 py-1 text-[10px] font-bold text-background-50 backdrop-blur">
                  生图 · 直出
                </span>
              </a>
              <figcaption className="p-4">
                <h4 className="line-clamp-1 text-sm font-bold text-foreground-950">{g.title}</h4>
                <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{g.desc}</p>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* moments video strip */}
        <div id="moment" className="mt-16 md:mt-20">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="font-label text-sm tracking-[0.3em] text-primary-600">BEST MOMENTS</p>
              <h3 className="mt-2 font-heading text-3xl font-black text-foreground-950">名场面回放</h3>
              <p className="mt-1.5 text-sm text-foreground-600">现场高能片段精选，点开即看，配好时间轴与来源</p>
            </div>
            <a href="#live" className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-600">
              更多片段 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {MOMENTS.map((m) => (
              <article key={m.title} className="group cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
                <div className="relative block aspect-video w-full overflow-hidden">
                  <img
                    src={m.image}
                    alt={`名场面视频片段：${m.title}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-2.5 top-2.5 rounded-full bg-accent-500 px-2.5 py-0.5 text-[10px] font-bold text-foreground-950">{m.tag}</span>
                  <span className="absolute bottom-2.5 right-2.5 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[10px] font-semibold text-background-50 backdrop-blur">
                    {m.duration}
                  </span>
                  <span className="absolute inset-0 m-auto flex h-11 w-11 items-center justify-center rounded-full bg-background-50/90 text-primary-600 opacity-0 transition-all duration-300 group-hover:opacity-100">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
                <div className="p-4">
                  <h4 className="line-clamp-2 text-sm font-bold leading-6 text-foreground-950 group-hover:text-primary-700">{m.title}</h4>
                  <p className="mt-2 flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-play-list-2-line text-primary-500"></i> {m.views}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}